<template>
    <div class="text-darkblue-800">

        <div class="w-full text-sm text-black bg-gray-light p-4">
            <div class="flex flex-row py-1">
                <div class="font-bold text-right w-1/2 pr-5">Subtotal</div>
                <div class="text-right w-1/2">£{{ subtotalPrice }}</div>
            </div>
            <div class="flex flex-row  py-1">
                <div class="font-bold text-right w-1/2 pr-5">VAT {{ tax }}%</div>
                <div class="text-right w-1/2">£ {{ taxPrice }}</div>
            </div>
            <div class="flex flex-row text-2xl font-bold pt-3">
                <div class="text-right w-1/2 pr-5">Total</div>
                <div class="text-right w-1/2">£{{ totalPrice }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import IconBasket from "./Icons/IconBasket";
import Separator from "./helpers/Separator";

export default {
    name: 'ProductPrice',
    components: { Separator, IconBasket },
    props: {
        subtotalPrice: {},
        tax: {},
        taxPrice: {},
        totalPrice: {}
    }
}
</script>